// TenantBootstrap (contracts 1.0 section 11): the input to `waypoint tenant bootstrap`.
import { z } from "zod";
import { Id, NonEmpty, strictObject, version } from "./primitives.js";
import { IssuerConfig } from "./identity.js";
import { ModelBinding } from "./model.js";
import { TenantPolicy } from "./policy.js";
import { PackVersion } from "./pack.js";
export const TenantBootstrap = strictObject({
    v: version(1),
    tenant: strictObject({ id: Id, name: NonEmpty }),
    orgs: z.array(strictObject({ id: Id, name: NonEmpty, libraries: z.array(Id) })).min(1),
    issuers: z.array(IssuerConfig).min(1),
    policy: TenantPolicy,
    modelBindings: z.array(ModelBinding),
    packs: z.array(strictObject({ id: Id, version: PackVersion, orgs: z.array(Id).optional() })),
    branding: strictObject({
        productName: NonEmpty,
        logoRef: NonEmpty.optional(),
        tokens: z.record(z.string().regex(/^--[a-z][a-z0-9-]*$/), z.string().max(64)).optional(),
    }).optional(),
}).superRefine((b, ctx) => {
    const orgIds = new Set(b.orgs.map((o) => o.id));
    if (orgIds.size !== b.orgs.length)
        ctx.addIssue({ code: "custom", path: ["orgs"], message: "org ids are unique" });
    for (const [i, iss] of b.issuers.entries())
        if (iss.tenantId !== b.tenant.id)
            ctx.addIssue({
                code: "custom",
                path: ["issuers", i, "tenantId"],
                message: "an issuer entry is bound to this tenant (D-37)",
            });
    for (const [i, p] of b.packs.entries())
        for (const o of p.orgs ?? [])
            if (!orgIds.has(o))
                ctx.addIssue({ code: "custom", path: ["packs", i, "orgs"], message: `unknown org ${o}` });
});
//# sourceMappingURL=bootstrap.js.map